// src/components/admin/PendingBadge.jsx
//
// The red badge on an admin button or tab: how many things wait there
// (utils/adminPendingApi.js). Nothing at 0 or while unknown.
import React from 'react';
import { Badge, Box } from '@mui/material';

export default function PendingBadge({ count, children, sx }) {
  const n = Number(count) || 0;
  if (!n) return sx ? <Box component="span" sx={{ display: 'inline-flex', ...sx }}>{children}</Box> : children;
  return (
    <Badge
      badgeContent={n} max={99} color="error" sx={sx}
      slotProps={{ badge: { 'aria-label': `${n} à traiter` } }}
    >
      {children}
    </Badge>
  );
}
